import { Flex, Button, Input, Text, Box, IconButton } from "@chakra-ui/react";
import { ArrowUpFromLine, Trash } from "lucide-react";
import { useRef, useState } from "react";
import { useAppContext } from "../../../contexts/AppContext";

const FileUpload = ({ label, onChange, accept, allowMultiple = false }) => {
  
  const { getFileIcon } = useAppContext();
  const fileInputRef = useRef();
  const [files, setFiles] = useState([]);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelection = (event) => {
    const selectedFiles = Array.from(event.target.files); // Convert FileList to Array
    if (selectedFiles.length > 0) {
      if (allowMultiple) {
        // If multiple files are allowed, add them to the list
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
      } else {
        // If only one file is allowed, replace the current file
        setFiles([selectedFiles[0]]);
      }
      
      if (onChange) {
        onChange(selectedFiles);
      }
    }
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <Flex direction="column" align="start" gap={1} flex={1}>
      <Text fontWeight="500" fontSize="11px" color="grey.900">
        {label}
      </Text>

      <Flex gap={1} direction={"column"} flex={1} w={"100%"}>
      {files.length > 0 && files.map((file, index) => (
        <Button
          key={index}
          w={"100%"}
          justifyContent={"space-between"}
          variant={"outline"}
          
        >         
          <Flex gap={2}>
            <Box w="12px">
              {getFileIcon(file.name)}
            </Box>
            <Text fontSize="sm" color="grey.900" fontWeight="500" maxW={"180px"} overflow={"hidden"} textOverflow={"ellipsis"}>
              {file.name}
            </Text>
          </Flex>
          <IconButton
            variant={"ghost"}
            size="xs"
            icon={<Trash size={14} />}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering file dialog on delete
              handleRemoveFile(index);
            }}
          />
        </Button>
      ))}
      </Flex>

      {/* Display the Upload button after files if multiple uploads are allowed */}
      {(allowMultiple || files.length === 0) && (
        <Button
          onClick={handleClick}
          colorScheme="brand"
          variant="outline"
          leftIcon={<ArrowUpFromLine size={16} />}
          size="sm"
          mt={files.length > 0 ? 2 : 0}
        >
          Upload file{allowMultiple ? 's' : ''}
        </Button>
      )}

      <Input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelection}
        accept={accept}
        display="none"
        multiple={allowMultiple}
      />
    </Flex>
  );
};

export default FileUpload;
